import React, { Component } from "react";
import PropTypes from "prop-types";
import Table from "@components/Table/Table";
import classNames from "classnames";

class ReportsTable extends Component {
	constructor(props) {
		super(props);
		this.state = {
			collapse: false,
		};
	}

	toggleTable = () => {
		const { collapse } = this.state;
		this.setState({ collapse: !collapse });
	};

	getRowKey = () => {
		const { reportType } = this.props;
		switch (reportType) {
			case "invoice_report":
				return ({ rowData, rowIndex }) => `${rowData.JobId}_${rowIndex}`;
			default:
				return "Id";
		}
	};

	render() {
		const { collapse } = this.state;
		const { data, header, hideTitle, tableColumn, onRow } = this.props;

		return (
			<div className="panel-table-wrapper legacy table-responsive">
				<If condition={!hideTitle}>
					<button
						type="button"
						onClick={this.toggleTable}
						tabIndex={0}
						className="table-title-btn"
					>
						<h4 className="table-title">
							<i
								className={classNames({
									rkf: true,
									"rkf-caret-right": collapse,
									"rkf-caret-down": !collapse,
								})}
							/>
							{header}
						</h4>
					</button>
				</If>
				<div className={classNames({ collapse })}>
					<Table
						rowKey={this.getRowKey()}
						className="compact-row"
						columns={tableColumn}
						data={data}
						onRow={onRow}
						isReport
					/>
				</div>
			</div>
		);
	}
}

ReportsTable.propTypes = {
	reportType: PropTypes.string.isRequired,
	data: PropTypes.array,
	header: PropTypes.string,
	tableColumn: PropTypes.array,
	onRow: PropTypes.func,
	hideTitle: PropTypes.bool,
};

ReportsTable.defaultProps = {
	data: [],
	header: "",
	tableColumn: undefined,
	onRow: undefined,
	hideTitle: false,
};

export default ReportsTable;
